import { render, staticRenderFns } from "./proofquery.vue?vue&type=template&id=4ec8435d&scoped=true&"
import script from "./proofquery.vue?vue&type=script&lang=js&"
export * from "./proofquery.vue?vue&type=script&lang=js&"
import style0 from "./proofquery.vue?vue&type=style&index=0&id=4ec8435d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec8435d",
  null
  
)

export default component.exports